export enum DebitorsPermissions {
  VIEW_DEBITOR_TYPE = "view_debitor_type",
  CREATE_DEBITOR_TYPE = "create_debitor_type",
  UPDATE_DEBITOR_TYPE = "update_debitor_type",
  DELETE_DEBITOR_TYPE = "delete_debitor_type",
  ARCHIVE_DEBITOR_TYPE = "archive_debitor_type",
}

export const DebitorsPermissionsText: Record<DebitorsPermissions, string> = {
  [DebitorsPermissions.VIEW_DEBITOR_TYPE]: "View Debitor Type",
  [DebitorsPermissions.CREATE_DEBITOR_TYPE]: "Create Debitor Type",
  [DebitorsPermissions.UPDATE_DEBITOR_TYPE]: "Update Debitor Type",
  [DebitorsPermissions.DELETE_DEBITOR_TYPE]: "Delete Debitor Type",
  [DebitorsPermissions.ARCHIVE_DEBITOR_TYPE]: "Archive Debitor Type",
};
